import { useState } from 'react';
import { $userStore } from '@lib/store/userManagement';
import { useRouteHook } from '@shared/hooks';
import { cn, PaletteUtils, RoutePaths } from '@shared/utils';
import type { UserProfileResponse } from '@shared/api/rest/users';
import { UserSidebarItems } from './userSidebarItems';
import { ChangePasswordModal, DeleteUserModal, EditDetailsModal, LockUserModal } from '../modals';

export interface IUserSidebarProps {
  user: UserProfileResponse;
}

export const UserSidebar = (props: IUserSidebarProps) => {
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [showLockModal, setShowLockModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const { navigate } = useRouteHook();

  const lockUserHandler = () => $userStore.events.lockUser(props.user.id);
  const unlockUserHandler = () => $userStore.events.unlockUser(props.user.id);
  const deleteUserHandler = async () => {
    const statusCode = (await $userStore.events.deleteUser(props.user.id)) as unknown as number;
    if (statusCode === 204) navigate(RoutePaths.users.onNavigate({ successDeleted: true }));
  };

  return (
    <>
      <div
        className={cn(
          'w-80 bg-white p-6 dark:bg-soft-black',
          PaletteUtils.isVcfcPalette && ['rounded-xl dark:border dark:border-gray-black dark:bg-soft-black', 'max-md:w-full'],
        )}
      >
        <UserSidebarItems
          user={props.user}
          setShowDetailsModal={() => setShowDetailsModal(true)}
          setShowLockModal={() => setShowLockModal(true)}
          setShowPasswordModal={() => setShowPasswordModal(true)}
          setShowDeleteModal={() => setShowDeleteModal(true)}
        />
      </div>
      <EditDetailsModal show={showDetailsModal} onClose={() => setShowDetailsModal(false)} user={props.user} />
      <ChangePasswordModal show={showPasswordModal} onClose={() => setShowPasswordModal(false)} userId={props.user.id} />
      <LockUserModal
        show={showLockModal}
        onClose={() => setShowLockModal(false)}
        locked={props.user.locked}
        onSave={props.user.locked ? unlockUserHandler : lockUserHandler}
      />
      <DeleteUserModal open={showDeleteModal} close={() => setShowDeleteModal(false)} deleteUser={deleteUserHandler} />
    </>
  );
};
